import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  ConceptModifiedPatchRequestModel,
  ConceptModifiedRequestModel
} from '../../../../pages/concepts/concepts.models'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ConceptModifiedModel } from './model/conceptsModified'

export const apiGetConceptsModifiedByContractProductID = async (
  contractProductID: number
): Promise<ConceptModifiedModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/ConceptModified/contractProduct/${contractProductID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiCreateConceptModified = async (
  request: ConceptModifiedRequestModel
): Promise<ConceptModifiedModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/ConceptModified`, request).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiUpdateConceptModified = async (
  request: ConceptModifiedPatchRequestModel
): Promise<ConceptModifiedModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/ConceptModified/${request.id}`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiDeleteConceptModified = async (
  conceptID: number
): Promise<ConceptModifiedModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/ConceptModified/${conceptID}`).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}
